import * as React from 'react';
import { INavLinks } from 'src/modules/Routing/types';
import { UserTypes } from 'src/modules/Auth/store/types';
import { linkNavs } from 'src/modules/Routing/hooks/navBars/linkNavs';
import { RouteModuleContext } from 'src/modules/Routing/context/RouteModule';

export const useNavBar = (): [INavLinks, UserTypes] => {
  const [routeModules, userType] = React.useContext(RouteModuleContext)
  const routes = React.useMemo(() => linkNavs(routeModules, userType), [routeModules])
  return [routes, userType];
}
